import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import {
  CompType,
  DenyPackType,
  LoginType,
  RechargeType,
} from "../base/baseEnum";
import { LangText } from "../base/baseType";

/** 支付项接口 */
export interface PayItem {
  /** 图片URL */
  img_url: string;
  /** 拒绝包 */
  // deny_pack: DenyPackType[];
  /** 唯一标识 */
  key: number;
  /** 状态 */
  status: number;
  /** 标题 */
  title: string;
}

/** 支付组件属性接口 */
export interface PayAttrs extends BaseComponentAttrs {
  /** 标题文本 */
  title_text: LangText;
  /** 数据列表 */
  list: PayItem[];
  /** 是否可点击 */
  // canClick: boolean;
}

/** 支付组件类 */
export class PayComponent extends BaseComponent<PayAttrs> {
  constructor(data: Partial<BaseComponent<PayAttrs>> = {}) {
    super(data);
    this.type = CompType.pay;
  }

  // /** 获取标题文本 */
  // public getTitleText(): LangText {
  //   return this.attrs.title_text;
  // }

  // /** 设置标题文本 */
  // public setTitleText(text: LangText): void {
  //   this.setAttrs({ title_text: text });
  // }

  // /** 获取指定语言的标题 */
  // public getTitleByLang(lang: string): string {
  //   return this.attrs.title_text?.[lang] || "";
  // }

  // /** 获取支付数据列表 */
  // public getPayItems(): PayItem[] {
  //   return this.attrs.data_list;
  // }

  // /** 设置支付数据列表 */
  // public setPayItems(items: PayItem[]): void {
  //   this.setAttrs({ data_list: items });
  // }

  // /** 获取是否可点击 */
  // public getCanClick(): boolean {
  //   return this.attrs.canClick;
  // }

  // /** 设置是否可点击 */
  // public setCanClick(canClick: boolean): void {
  //   this.setAttrs({ canClick });
  // }
}

// 使用示例
// const payData: Partial<BaseComponent<PayAttrs>> = {
//   id: "673c61f30552d8e3fc789f19",
//   type: CompType.pay,
//   variant: "",
//   title: "支付通道1",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "footer_pay",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_text: {
//       "1": "Payment Channels",
//       "4": "支付通道",
//       "11": "Canais de Pagamento",
//       "12": "Canales de pago",
//     },
//     data_list: [
//       {
//         img_url: "https://img.engames.com/afun/BANK.svg",
//         deny_pack: [],
//         key: 1732010556179,
//         status: 1,
//         title: "BANK",
//       },
//     ],
//     canClick: false,
//   },
// };
